module.exports = __webpack_public_path__ + "media/edited-lagu.bb830e1b.mp3";